
/* eslint-disable no-shadow */

// initial state
const state = {
  title: 'Bionic Metrics',
  hideOnScroll: false
};

// getters - all receive state as first argument
const getters = {
  getTitle: (state) => state.title,
  getHideOnScroll: (state) => state.hideOnScroll
};

// actions
const actions = {};

// mutations
const mutations = {
  setTitle(state, title) {
    state.title = title;
  },
  setHideOnScroll(state, hideOnScroll) {
    state.hideOnScroll = hideOnScroll;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
